import { useState, useEffect } from "react";

const useDeviceType = (): string => {
  const [deviceType, setDeviceType] = useState<string>("desktop");

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();

    // Detect mobile devices using user agent string
    if (/android|iphone|ipod|mobile/i.test(userAgent)) {
      setDeviceType("mobile");
    } else {
      setDeviceType("desktop");
    }

    // Optionally listen for window resize events to detect if the device is mobile or desktop
    const handleResize = (): void => {
      if (window.innerWidth <= 768) {
        setDeviceType("mobile");
      } else {
        setDeviceType("desktop");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return deviceType;
};

export default useDeviceType;
